import React from "react";
import styled from "styled-components";
import { zoomViewState } from "@stores/popup";
import { useAtom } from "jotai";
//import Panzoom from "@panzoom/panzoom";
import WZoom from "vanilla-js-wheel-zoom";

import { useEffect } from "react";

const Wrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 40;
  background-color: #3e3a62;
  opacity: 0;
  transition opacity 0.4s;

  .pan-zoom {
    position: relative;
    width: 1920px;
    height: 1200px;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1) !important;
    //transition: none !important;
  }
`;

const ImgWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  &.single {
    //justify-content: center;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  left: 0;
  top: 0px;
  width: 145px;
  height: 123px;
  margin-top: 30px;
  background: url(${require("@assets/img/icon_popup_back.png")});
  background-size: 100% 100%;
`;

const ZoomView = () => {
  const [zoomViewInfo, setInfo] = useAtom(zoomViewState);
  const { page, pages } = zoomViewInfo;
  const viewPage = page === 1 ? [0] : [page - 2, page - 1];

  useEffect(() => {
    const zzzView = WZoom.create(document.querySelector(".pan-zoom"), {
      type: "html",
      width: viewPage.length === 1 ? 1500 : 3000,
      height: 1500,
      minScale: 0.55,
      maxScale: 3,
      speed: 10,
      zoomOnClick: false,
    });

    document.querySelector(".z-wrap").style.opacity = 1;
    zzzView.zoomUp();

    return () => {
      zzzView.destroy();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrap className="z-wrap">
      <div className="pan-zoom">
        <ImgWrap className={viewPage.length === 1 ? "single" : ""}>
          {viewPage.map((p, i) => {
            return <img key={i} src={pages[p].book} alt="" />;
          })}
        </ImgWrap>
      </div>

      <CloseButton
        type="button"
        onClick={() => {
          setInfo({
            open: false,
            page: 0,
            pages: [],
          });
        }}
      />
    </Wrap>
  );
};
export default React.memo(ZoomView);
